import React from 'react';
import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';

export const WizardStepInput = ({ name, setName, description, setDescription, onNext, loading }) => {
    return (
        <div className="space-y-6">
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Marca Propuesta</label>
                <div className="relative">
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Ej: Star Coffee"
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                        disabled={loading}
                    />
                </div>
                <p className="mt-2 text-xs text-gray-500">
                    Ingresa el nombre principal, sin eslóganes ni puntuación innecesaria.
                </p>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Descripción Comercial</label>
                <div className="relative">
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        rows={4}
                        placeholder="Ej: Venta de granos tostados de café arábigo."
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors resize-none"
                        disabled={loading}
                    />
                </div>
                <p className="mt-2 text-xs text-gray-500">
                    Describe en lenguaje natural los productos o servicios. Nuestro modelo AI sugerirá las clases correctas.
                </p>
            </div>

            <div className="pt-6 flex justify-end items-center">
                <Button
                    onClick={onNext}
                    disabled={loading || !name.trim() || !description.trim()}
                    className="w-full md:w-auto bg-indigo-600 hover:bg-indigo-700 text-white min-w-[120px]"
                >
                    {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
                    {loading ? 'Surgiriendo...' : 'Siguiente Paso'}
                </Button>
            </div>
        </div>
    );
};
